import React from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import pluralize from 'pluralize';

export function format(input, short = false) {
  if (Number.isNaN(input)) {
    return null;
  }
  let num = input;
  let unit = short ? 'd' : 'day';
  if (input > 365) {
    num = input / 365;
    unit = short ? 'yr' : 'year';
  } else if (input > 30) {
    num = input / 30;
    unit = short ? 'mo' : 'month';
  }
  let out = accounting.formatNumber(num, 1);
  out = out.replace('.0', '');
  return `${out} ${pluralize(unit, num)}`;
}

function TenureDisplay(props) {
  const { value, short } = props;
  const v = format(value, short);
  return (
    <span className="tenure-display">{v}</span>
  );
}

TenureDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
  ]),
  short: PropTypes.bool,
};
TenureDisplay.defaultProps = {
  value: null,
  short: false,
};
export default TenureDisplay;
